import React, { useState } from "react";
import { FaFacebook,  FaInstagram,  FaPhoneAlt, FaMapMarkerAlt, FaEnvelope, FaTaxi, FaTiktok, FaWhatsapp, FaTripadvisor } from 'react-icons/fa';
import './footer.css';
import { collection, addDoc, serverTimestamp } from "firebase/firestore";   
import { db } from '../FirebaseComp/firebase';



function FooterComp() {


  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    if (email.trim() === "") {
      alert("Please enter a valid email");
      return;
    }

    setLoading(true);
    try {
      await addDoc(collection(db, "newsletter"), {
        email: email,
        subscribedAt: serverTimestamp()
      });
      setSuccess(true);
      setEmail(""); // clear input
    } catch (error) {
      console.error("Error adding email: ", error);
      alert("Something went wrong. Please try again.");
    }
    setLoading(false);
  };







  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Company Info */}
        <div className="footer-section company-info">
<div className="logo-container">
  <img 
    src="/round-logo.png" 
    alt=" Logo" 
    className="logo-image"
  />
  <span className="company-name">Southern Rehab Care</span>
</div>

          <p className="company-description">
          Southern Rehab Care provides high-quality artificial limbs, scoliosis braces, orthopedic rehabilitation support, and mobility solutions in Sri Lanka. Regain mobility with professional care.
          </p>
          <div className="social-icons">
          <a 
  href="https://www.facebook.com/share/1FVenBJvR3/" 
  className="social-icon" 
  target="_blank" 
  rel="noopener noreferrer"
>
  <FaFacebook />
</a>

<a 
  href="https://www.instagram.com/southernrehabcare?igsh=MTVldGQxbmVyZ3J5MQ==" 
  className="social-icon" 
  target="_blank" 
  rel="noopener noreferrer"
>
  <FaInstagram />
</a>

<a 
  href="https://wa.me/94777439610?text=Hello%2C%20I%20need%20assistance%20with..." 
  className="social-icon" 
  target="_blank" 
  rel="noopener noreferrer"
>
  <FaWhatsapp />
</a>


          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3 className="section-title-footer">Quick Links</h3>
          <ul className="link-list">
            <li><a href="/">Home</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/spinal-orthotics">Scoliosis & Spinal Health Program</a></li>
            <li><a href="/physiotherapy-for-rehabilitation">Physiotherapy For Rehabilitation</a></li>
            <li><a href="/aboutus">About Us</a></li>
            <li><a href="/contactus">Contact</a></li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-section">
          <h3 className="section-title-footer">Our Services</h3>
          <ul className="link-list">
            <li><a href="/upper-extremity-prosthetics">Upper Extremity Prosthetics & Orthotics</a></li>
            <li><a href="/lower-extremity-prosthetics">Lower Extremity Prosthetics & Orthotics</a></li>
            <li><a href="/spinal-orthotics">Scoliosis Orthotics</a></li>
            <li><a href="/reha-mobility">Reha Mobility Solutions</a></li>
            <li><a href="/orthopedics-children">Orthopedics for Children</a></li>
          </ul>
        </div>
     







        {/* Contact Info */}
        <div className="footer-section ">
          <h3 className="section-title-footer">Contact Us</h3>
          <ul className="contact-list">
            <li className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
             <a href="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3967.474356088331!2d80.2199589!3d6.0665819999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae171254a7eef49%3A0x635255ca4318ee2c!2sSouthern%20REHAB%20care!5e0!3m2!1sen!2slk!4v1773508059255!5m2!1sen!2slk" target="_blank">
              <span>Hirimbura Rd, Karapitiya, Sri Lanka</span>
            </a>
            </li>
            <li className="contact-item">
              <FaPhoneAlt className="contact-icon" />
              <a href="tel:+94777439610">
                <span>077 743 9610</span>
              </a>
           |

             <a href="tel:+940714476402">
                <span>071 447 6402</span>
              </a>
            </li>

            <li className="contact-item">
              <FaEnvelope className="contact-icon" />
        <a href="mailto:info@southernrehabcare.lk?subject=Inquiry&body=Hello Southern Rehab Care,">
          info@southernrehabcare.lk
        </a>
            </li>
          </ul>




          
  <div className="newsletter">
      <h4 className="newsletter-title">Newsletter</h4>

      <div className="newsletter-input">
        <input
          type="email"
          placeholder="Your email"
          className="email-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          className="subscribe-btn"
          onClick={handleSubscribe}
          disabled={loading}
        >
          {loading ? "Subscribing..." : "Subscribe"}
        </button>
      </div>

      {success && (
        <p className="success-message">
          ✅ You have successfully subscribed to Southern Rehab Care
        </p>
      )}
    </div>








        </div>
      </div>

      {/* Copyright */}
      <div className="copyright-section">
        <p>&copy; {new Date().getFullYear()} Southern Rehab Care. All Rights Reserved. |  Designed and Developed by 
  <a 
    className="glaxmore-link" 
    href="https://www.glaxmore.com" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    &ensp; GLAXMORE
  </a>
</p>
      </div>
    </footer>
  );
}

export default FooterComp;